import { useState, useEffect } from 'react';

const BREAKPOINTS = {
  mobile: 768, // 0-767px
  tablet: 1024, // 768-1023px
  desktop: 1024, // 1024px+
};

export const useResponsive = () => {
  const [screenSize, setScreenSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 375,
    isMobile: typeof window !== 'undefined' ? window.innerWidth < BREAKPOINTS.mobile : true,
    isTablet:
      typeof window !== 'undefined'
        ? window.innerWidth >= BREAKPOINTS.mobile && window.innerWidth < BREAKPOINTS.desktop
        : false,
    isDesktop: typeof window !== 'undefined' ? window.innerWidth >= BREAKPOINTS.desktop : false,
  });

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setScreenSize({
        width,
        isMobile: width < BREAKPOINTS.mobile,
        isTablet: width >= BREAKPOINTS.mobile && width < BREAKPOINTS.desktop,
        isDesktop: width >= BREAKPOINTS.desktop,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return screenSize;
};
